import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { ALLGEMEINE_HINWEISE_FELDERNAME, ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import { ANTRAG_TYP, KMU_ERFORDERLICHKEIT, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { checkIfAnyKmusHasComment, checkIfSpecificKmuHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import AntragstellerKmuErklaerungGlobal, { getFormStrucAntragstellerKmuErklaerungGlobal } from './content/AntragstellerKmuErklaerungGlobal';

// import schemas
import KMUHinweiseSchema from 'src/lib/paths/allgemeinehinweisekmu_FULL_Paths.json';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getAntragstellerName, getVerbundPartnerName } from '../../../application-helper-function/AppHelperfunctions';
const P = Schema.attributes;
const KMU_P = KMUHinweiseSchema.attributes;

export const TreeStructureSelbstErklaerungKMUGlobal = (application: any, readOnly: boolean, allgemeineHinweiseKMU: any) => {
	let treeNodes: TreeNodeType[] = [];

	const anzahlHinweis =
		get(allgemeineHinweiseKMU, KMU_P.Hinweise.path, []).length > 0 ? get(allgemeineHinweiseKMU, KMU_P.Hinweise.path, []).length : 0;
	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const kmuKonfigurationErforderlichkeit = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_KMU_Erklaerung_Erforderlichkeit.path,
		'',
	);

	const showKMUErklaerung = shouldShowKMUErklaerung(antragsTyp, kmuKonfigurationErforderlichkeit);

	if (showKMUErklaerung) {
		const antragstellerName = getAntragstellerName(application);
		treeNodes = [
			{
				label: 'KMU-Selbsterklärung',
				content: <ApplicationHeading title='KMU-Selbsterklärung' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyKmusHasComment(readOnly, application),
				children: [
					...get(allgemeineHinweiseKMU, KMU_P.Hinweise.path, []).map((ele: any, i: number) => ({
						label: `${Roman.toRoman(i + 1)}. ${get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Titel)}`,
						content: (
							<>
								<Box sx={{ mt: '1rem' }}>
									<Typography variant='h3' component={'h3'}>
										{get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Untertitel, '')}
									</Typography>
									<MarkdownRenderer markdown={get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Inhalt, '')} />
								</Box>
							</>
						),
					})),
					{
						label: `${Roman.toRoman(anzahlHinweis + 1)}. KMU-Erklärung: ${antragstellerName}`,
						content: (
							<AntragstellerKmuErklaerungGlobal
								unternehmenId={get(application, `${P.Antragstellende_Organisation.path}.id`)}
								unternehmenName={antragstellerName}
								hasComment={checkIfSpecificKmuHasComment(
									readOnly,
									application,
									get(application, `${P.Antragstellende_Organisation.path}.id`),
								)}
							/>
						),
						formStruc: getFormStrucAntragstellerKmuErklaerungGlobal(application, get(application, `${P.Antragstellende_Organisation.path}.id`)),
						hasComment: checkIfSpecificKmuHasComment(readOnly, application, get(application, `${P.Antragstellende_Organisation.path}.id`)),
					},
					...get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
						const hasCommentSelectedKmu = checkIfSpecificKmuHasComment(
							readOnly,
							application,
							get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`),
							get(ele, ANTRAG_VERBUNDPARTNER.PositionID),
						);
						const vPartnerName = getVerbundPartnerName(ele, i);
						return {
							label: `${Roman.toRoman(i + anzahlHinweis + 2)}. KMU-Erklärung: ${vPartnerName}`,
							content: (
								<AntragstellerKmuErklaerungGlobal
									unternehmenId={get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`)}
									positionId={get(ele, ANTRAG_VERBUNDPARTNER.PositionID)}
									unternehmenName={vPartnerName}
									hasComment={hasCommentSelectedKmu}
								/>
							),
							formStruc: getFormStrucAntragstellerKmuErklaerungGlobal(application, get(ele, `id`), get(ele, ANTRAG_VERBUNDPARTNER.PositionID)),
							hasComment: hasCommentSelectedKmu,
						};
					}),
				],
			},
		];
	}

	return treeNodes;
};

function shouldShowKMUErklaerung(typ: string, erforderlichkeit: string) {
	if (erforderlichkeit === KMU_ERFORDERLICHKEIT.NichtErforderlich) return false;
	if (erforderlichkeit === KMU_ERFORDERLICHKEIT.InAntragUndSkizze) return true;
	if (typ === ANTRAG_TYP.Skizze) return erforderlichkeit === KMU_ERFORDERLICHKEIT.NurInSkizze;
	if (typ === ANTRAG_TYP.Antrag) return erforderlichkeit === KMU_ERFORDERLICHKEIT.NurImAntrag;

	return false;
}
